export { default } from './svg/close-form.svg';
